var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticStyle:{"justify-content":"center","align-items":"center","display":"flex","margin-top":"20px"}},[_vm._v(" You have not been given permission to view data for this site. Please contact your system administrator. ")])])
}]

export { render, staticRenderFns }